import React, { useState } from "react";
import {
  AuthFormData,
  LoginSignUpProps,
  RegFormData,
  RegFormErrors,
  RegTouchFields,
} from "../common/types";
import { AuthForm, RegForm } from "../ui/Forms/LoginAndCreateAccForm";
import { SignUpAndIoginLayout } from "../common/FormLayouts";

const LoginSignUp: React.FC<LoginSignUpProps> = ({ isLogin }) => {
  //initial registration form data
  const [regFormData, setRegFormData] = useState<RegFormData>({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });
  //initial authentication form data
  const [authFormData, setauthFormData] = useState<AuthFormData>({
    email: "",
    password: "",
  });

  //initial touch state
  const [touched, setTouched] = useState<RegTouchFields>({
    name: false,
    email: false,
    password: false,
    confirmPassword: false,
    otp: false,
  });

  //initial form errors
  const [errors, setErrors] = useState<RegFormErrors>({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: ""
  });

  return (
    <SignUpAndIoginLayout>
      <p className="greeting">Hello and Welcome</p>
      <p className="instruction">
        <strong>{isLogin ? "Sign in" : "Create an account"}</strong>
        to access the portfolio dashboard
      </p>
      <div className="CoverDiv">
        {isLogin ? (
          <AuthForm
            isLogin={isLogin}
            authFormData={authFormData}
            setAuthFormData={setauthFormData}
          />
        ) : (
          <RegForm
            isLogin={isLogin}
            regFormData={regFormData}
            setRegFormData={setRegFormData}
            errors={errors}
            setErrors={setErrors}
            touched={touched}
            setTouched={setTouched}
          />
        )}
      </div>
      {/* </div> */}
    </SignUpAndIoginLayout>
  );
};

export default LoginSignUp;
